import PptxGenJS from "pptxgenjs";
import dayjs from "dayjs";
import {
  BACKGROUND_IMAGE_PATH,
  BRAND_LOGO,
  getMediaContent,
  OPACITY_OVERLAY,
} from "./components";

export const TITLE_MASTER = "TITLE_MASTER";

export const titleMasterSlide: PptxGenJS.SlideMasterProps = {
  title: TITLE_MASTER,
  background: {
    color: "#FFFFFF",
    transparency: 0.8,
    data: getMediaContent(BACKGROUND_IMAGE_PATH),
  },
  objects: [
    OPACITY_OVERLAY,
    BRAND_LOGO,
    {
      placeholder: {
        options: {
          name: "title",
          type: "title",
          x: 0.94,
          y: 2.85,
          w: 12.29,
          h: 1.9,
          fontSize: 65,
          align: "left",
          valign: "bottom",
        },
        text: "Title",
      },
    },
    {
      placeholder: {
        options: {
          name: "candidate-name",
          type: "body",
          x: 0.94,
          y: 4.96,
          w: 8.51,
          h: 0.39,
          fontSize: 18,
          align: "left",
        },
        text: "Candidate Name",
      },
    },
    {
      placeholder: {
        options: {
          name: "candidate-position-role",
          type: "body",
          x: 0.94,
          y: 5.35,
          w: 8.51,
          h: 0.77,
          fontSize: 18,
          align: "left",
        },
        text: "Candidate Position/Role",
      },
    },
    {
      placeholder: {
        options: {
          name: "date",
          type: "body",
          x: 0.94,
          y: 6.96,
          w: 4.93,
          h: 0.3,
          fontSize: 14,
          align: "left",
          bold: true,
          color: "#0a2fb5",
        },
        text: dayjs().format("MMMM YYYY"),
      },
    },
  ],
};
